import React from 'react';
import { Grid, Row, Col, PageHeader, Checkbox, Glyphicon, FormGroup, HelpBlock, ControlLabel, FormControl, Well, InputGroup } from 'react-bootstrap';
import Checkout from './Checkout';
import './Buy.css';
import EULA from './EULA';


//const regexEmail = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const regexNum = /^[0-9]+$/
export const base_price = 9.99;

const prodEndpoint = 'https://api.splinter-log.com/charge';
//const devEndpoint = 'http://localhost:8080/charge';
const endpoint = prodEndpoint;

class Buy extends React.Component {
	constructor(props) {
		super(props);
		this.state = { email: '',
					   email_conf: '',
					   licenses: '1',
					   showEula: false,
					   chargeEndpoint: endpoint,
					   isEulaAccepted: false,
					   eulaValidationState: null
					 };

		this.handleEmailChange = this.handleEmailChange.bind(this);
		this.openEula = this.openEula.bind(this);
		this.closeEula = this.closeEula.bind(this);
		this.handleEmailConfChange = this.handleEmailConfChange.bind(this);
		this.handleLicenseChange = this.handleLicenseChange.bind(this);
		this.handleOwnerChange = this.handleOwnerChange.bind(this);
		this.acceptEula = this.acceptEula.bind(this);
		this.getPrice = this.getPrice.bind(this);
		this.handleEulaChange = this.handleEulaChange.bind(this);
		this.validateForm = this.validateForm.bind(this);

	}

	handleOwnerChange(event) {
		this.setState({owner: event.target.value});
	}

	handleEmailConfChange(event) { 
		this.setState({ email_conf: event.target.value });
	}

	handleEmailChange(event) { 
		this.setState({ email: event.target.value });
	}

	handleEulaChange(event) { 
		this.setState({isEulaAccepted: event.target.checked});	   
	}
	
	closeEula() {
		this.setState({showEula: false});
	}

	acceptEula() { 
		this.setState({isEulaAccepted: true, showEula: false});
	}

	openEula(event) {
		event.preventDefault();

		this.setState({showEula: true});
	}

	getPrice() {
		if(this.isLicenseNumInvalid(this.state.licenses)) { 
			return '--';
		}

		let price = this.state.licenses * base_price;
		return price.toFixed(2);
	}

	handleLicenseChange(event) { 
		var num = parseInt(event.target.value, 10);
		 
		this.setState( { licenses: num  });
		
	}

	isLicenseNumInvalid(num) {
		return isNaN(num) || !regexNum.test(num) || num < 1 || num > 100;
	}

	
	validateForm(event) {
		let eulaValidationState = null;
		let licenseValidationState = null;
		let ownerValidationState = null;
		let emailValidationState = null;

		if(!this.state.isEulaAccepted) { 
			eulaValidationState = 'error';
		}
		if(this.isLicenseNumInvalid(this.state.licenses)) { 
			licenseValidationState = 'error';
		}
		if(!this.state.owner) { 
			ownerValidationState = 'error';
		}
		if(!this.state.email || this.state.email !== this.state.email_conf) { 
			emailValidationState = 'error';
		}

		this.setState({eulaValidationState: eulaValidationState,
					   licenseValidationState: licenseValidationState,
					   ownerValidationState: ownerValidationState,
					   emailValidationState: emailValidationState});
		let isValid = eulaValidationState === null && licenseValidationState === null && ownerValidationState === null && emailValidationState === null;

		if(!isValid && event != null) {
			event.preventDefault();
		}
		return isValid;
	}

	render() { 
		let now = new Date();
		now = (now.getMonth() +1) + '/' + now.getDate() + '/' + now.getFullYear();

		let paymentDetails = { 
			summaryItemNames: ['Date', 'Licensee', 'Email'],
			summaryItemValues: [now, this.state.owner, this.state.email],
			lineItemNames: [this.state.licenses + 'x Splinter License'],
			lineItemValues: ['$' + this.getPrice()],
			total: {
				price: '$' + this.getPrice(),
				currency: 'USD'
			}
		};

		return (
			<div className="pageContents">

				<PageHeader>Buy Splinter</PageHeader>
				
				<Grid>
					<Row>
						<Col sm={4} md={4} lg={6}>
							<h3>Benefits of Licensing</h3>
							<ul>
								<li>Unlimited use of the current verison of Splinter without ads or nagging windows.</li>
								<li>Access to pro (license-only) features.</li>
								<li>Licensed members have their feature requests prioritized (no guarantees on feature implementation).</li>
								<li>Access to pre-release features and betas (opt-in for email notifications).</li>
								<li>Support current & future development of Splinter.</li>
							</ul>
							

							<h3>Electronic Licenses</h3>
							<p>Once purchased, you will receive a copy of the license through the website and a backup copy in your email. To enable the license, download Splinter and enter it through <code>Settings > Licenses</code>.</p>
							<p>When purchasing licenses in bulk (more than 1), you will still receive a single license which you can distribute to multiple computers.</p>

							<h3>Lost a License?</h3>
							<p>All licenses are emailed when you purchase them. If you still can't locate it, email <a href="mailto:support@splinter-log.com">support@splinter-log.com</a>.</p>

						</Col>
						<Col sm={8} md={8} lg={6}>
							<form action={this.state.chargeEndpoint} method="post" id="payment-form" onSubmit={this.validateForm}>
								<Well className="formContainer" id="formPersonal">
									<FormGroup bsSize="small" controlId="owner" validationState={this.state.ownerValidationState}>
								      <ControlLabel>License Owner</ControlLabel>
								      <InputGroup>
								        <InputGroup.Addon><Glyphicon glyph="user"/></InputGroup.Addon>
								      	<FormControl name="name" type="text" required placeholder="Your Name" onChange={this.handleOwnerChange} />
								      </InputGroup>
								      <HelpBlock>The name associated with the license.</HelpBlock>
								    </FormGroup>

									<FormGroup bsSize="small" controlId="email" validationState={this.state.emailValidationState}>
								      <InputGroup>
									      <InputGroup.Addon>@</InputGroup.Addon>
									      <FormControl name="email" type="email" required placeholder="Email Address" onChange={this.handleEmailChange} />
								      </InputGroup>
								      <HelpBlock>Your email is used for license retrieval and is not shared with anyone.</HelpBlock>
								      <FormControl.Feedback />
								    </FormGroup>
									<FormGroup bsSize="small" controlId="emailConfirm" validationState={this.state.emailValidationState}>
				  				      <InputGroup>
									  	<InputGroup.Addon>@</InputGroup.Addon>
								      	<FormControl type="email" required placeholder="Confirm Email" onChange={this.handleEmailConfChange} />
								      </InputGroup>
									  <FormControl.Feedback />
				  				   </FormGroup>
				  				   <Checkbox name="email_opt_in">Send me occasional email updates about new Splinter releases.</Checkbox>

							    </Well>

							    <Well id="formPayment">
							    	<FormGroup bsSize="small" controlId="numLicense" validationState={this.state.licenseValidationState}>
							    		<ControlLabel >Number of Licenses</ControlLabel>
									    <InputGroup >
								        	<InputGroup.Addon><Glyphicon glyph="duplicate"/></InputGroup.Addon>
							    			<FormControl name="licenses" type="number" required defaultValue="1" min="1" max="100" onChange={this.handleLicenseChange}/>
							    		</InputGroup>
							    	</FormGroup>

							       <p className="clear" />
							  	   <Checkbox validationState={this.state.eulaValidationState} 
							  	   			  required name="eula" onChange={this.handleEulaChange} 
							  	   			  checked={this.state.isEulaAccepted} >
							  	   			  I've read and agree to the <a onClick={this.openEula}>End-User License Agreement.</a>
							  	   </Checkbox>

								  <div>
								  	<div className="left">
								  		<h4>Total</h4>
								  	</div>
								  	<div className="right">
								  		<h4>${this.getPrice()} <small>USD</small></h4>
								  		<FormControl type="hidden" name="price" value={this.getPrice()} />
								  		<FormControl type="hidden" name="version" value="1.0" />
								  	</div>
								  </div>
								  <p className="clear" />

								  <Checkout form_id="payment-form"
								  			paymentDetails={paymentDetails}
								  			fetchPrice={this.getPrice}
								  			fetchCurrency={() => 'USD'}
								  			fetchLicense={() => this.state.licenses}
								  			formValidator={this.validateForm} />
								  
								  <div className="clear"/>
								</Well>
							</form>
						</Col>
					</Row>
				</Grid>
						
				<EULA show={this.state.showEula} onAccept={this.acceptEula} close={this.closeEula}/>

			</div>
			);
	}
}


export default Buy;





// WEBPACK FOOTER //
// ./src/Buy.js